import React, {useState, useEffect} from 'react'
import { apiMy, apiMyEdit } from 'api-methods'
import Header from "../components/Header"
import BreadCrumbs from "../components/BreadCrumbs"
import Notification from "../components/Notification"
import Footer from "../components/Footer"
import '../css/EditCompany.css'
import {Loaders} from "../components/Loaders"
import {useLocation, useNavigate} from "react-router-dom"
import { handleAuthErrorAndRedirect, isSuccessStatus } from '../utils/authError'

const EditCompany = () => {

    const [userData, setUserData] = useState(null)
    const [formData, setFormData] = useState({companyName: '', enabled: '', createdAt: '', country: '', zip: '', state: '', city: '', companyEmail: ''})
    const [notification, setNotification] = useState(null)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        apiMy()
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (data.code === 500) {
                    setUserData({})
                } else if (isSuccessStatus(data.code)) {
                    if (typeof(data.data) === 'string') {
                        data.data = JSON.parse(data.data)
                    }

                    setUserData(data.data)
                    setFormData({
                        login: data.data.login || '',
                        userName: data.data.userName || '',
                        userEmail: data.data.userEmail || '',
                        companyName: data.data.customerOptions?.company?.name || '',
                        zip: data.data.customerOptions?.contacts?.zip || '',
                        state: data.data.customerOptions?.contacts?.state || '',
                        city: data.data.customerOptions?.contacts?.city || '',
                        companyEmail: data.data.customerOptions?.contacts?.email || ''
                    })
                } else {
                    navigate('/login', {state: { from: location.pathname + location.search }})
                }
            })
            .catch(_ => {})
    }, [])

    const showNotification = (message, type = 'success') => {setNotification({ message, type })}
    const hideNotification = () => {setNotification(null)}
    const handleInputChange = (e) => {const { name, value } = e.target; setFormData(prev => ({...prev, [name]: value}))}

    const handleSave = () => {
        let forApiReq = {
            "company": {
                "name": formData.companyName,
                "code": "",
                "email": "",
                "website": "",
                "phone": "",
                "fax": "",
                "address": "",
                "kpp": ""
            },
            "contacts": {
                "name": "",
                "email": formData.companyEmail,
                "website": "",
                "phone": "",
                "city": formData.city,
                "zip": formData.zip,
                "country": "RUS",
                "state": formData.state,
                "fax": "",
                "job": ""
            }
        }
        apiMyEdit(forApiReq)
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code) || data.code === 204) {showNotification('Данные успешно сохранены!', 'success')} else {showNotification('Ошибка сохранения', 'error')
                }
            })
            .catch(_ => {showNotification('Ошибка сохранения', 'error')})
            .finally(_ => {})
    }

    if (!userData) {return <div className="loadersComponent"><Loaders /></div>}

    return <div className="pageEditCompany">
        <Header/>
        <BreadCrumbs title={'Профиль компании → Параметры'}/>
        <div className="pageEditCompanyContent">
            <div className="user-form-container">
                <div className="form-grid">

                    {/* Левая колонка */}
                    <div className="form-column">
                        <div className="form-title">Основная информация</div>
                        <div className="form-field"><label>Название компании*</label><div><input type="text" name="companyName" value={formData.companyName} onChange={handleInputChange} placeholder="Не указано"/></div></div>
                        <div className="form-field"><label>Статус</label><div className="text-value">{userData.enabled ? 'Активен' : 'Неактивен'}</div></div>
                        <div className="form-field"><label>Дата создания</label><div className="text-value">{userData.createdAt}</div></div>
                    </div>

                    {/* Правая колонка */}
                    <div className="form-column">
                        <div className="form-title">Адрес</div>
                        <div className="form-field"><label>Страна</label><div className="text-value">{userData.customerOptions?.contacts?.country}</div></div>
                        <div className="form-field"><label>Почтовый индекс</label><div><input type="text" name="zip" value={formData.zip} onChange={handleInputChange} placeholder="Не указан"/></div></div>
                        <div className="form-field"><label>Область*</label><div><input type="text" name="state" value={formData.state} onChange={handleInputChange} placeholder="Не указан"/></div></div>
                        <div className="form-field"><label>Город*</label><div><input type="text" name="city" value={formData.city} onChange={handleInputChange} placeholder="Не указан"/></div></div>
                        <div className="form-field"><label>Email компании*</label><div><input type="text" name="companyEmail" value={formData.companyEmail} onChange={handleInputChange} placeholder="Не указан"/></div></div>
                    </div>
                </div>

                {/* Кнопки */}
                <div className="allPagesStyleButton-posLeft">
                    <div className="allPagesStyleButton-group">
                        <div className="allPagesStyleButton" onClick={handleSave}>Сохранить</div>
                    </div>
                </div>

                {/* Уведомления */}
                {notification && (<Notification message={notification.message} type={notification.type} onClose={hideNotification} duration={3000}/>)}
            </div>
        </div>
        <br/>
        <br/>
        <br/>
        <Footer/>
    </div>
}

export default EditCompany

